(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pq-product-content-countdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('pq-product-content-countdown')) {
      customElements.define(
        'pq-product-content-countdown',
        class PqProductContentCountdown extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0; // 内部剩余时间（毫秒）
            this.isFixedMode = false; // 是否为固定时长模式
          }

          connectedCallback() {
            this.initCountdown();
          }

          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }

          initCountdown() {
            const startTsStr = this.getAttribute('data-start');
            const endTsStr = this.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr) * 1000 : null;
            const endTime = parseInt(endTsStr) * 1000;
            const now = Date.now();

            // 逻辑判断：
            if (startTime) {
              // 模式 A：固定时长模式 (结束时间 - 开始时间)
              // 只有当现在时间 >= 开始时间，且 <= 结束时间时才显示
              if (now >= startTime && now <= endTime) {
                this.isFixedMode = true;
                this.timeRemaining = endTime - startTime; // 固定为设置的差值
                this.style.display = 'block';
              } else {
                this.style.display = 'none';
                return;
              }
            } else {
              // 模式 B：实时模式 (结束时间 - 现在时间)
              if (now <= endTime) {
                this.isFixedMode = false;
                this.timeRemaining = endTime - now;
                this.style.display = 'block';
              } else {
                this.style.display = 'none';
                return;
              }
            }

            this.renderTime(this.timeRemaining);
            this.startTimer();
          }

          startTimer() {
            this.countdownInterval = setInterval(() => {
              const endTsStr = this.getAttribute('data-end');
              const startTsStr = this.getAttribute('data-start');

              const now = Date.now();
              const startTime = startTsStr ? parseInt(startTsStr) * 1000 : null;
              const endTime = parseInt(endTsStr) * 1000;

              if (startTime && now < startTime) {
                this.timeRemaining = startTime - now;
              } else if (now <= endTime) {
                this.timeRemaining = endTime - now;
              } else {
                this.timeRemaining = 0;
                this.renderTime(0);
                this.style.display = 'none';
                clearInterval(this.countdownInterval);
                return;
              }

              this.renderTime(this.timeRemaining);
            }, 1000);
          }

          renderTime(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.querySelector('.days');
            const hoursElement = this.querySelector('.hrs');
            const minutesElement = this.querySelector('.min');
            const secondsElement = this.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pq-product-content-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('pq-product-content-product-set')) {
      customElements.define(
        'pq-product-content-product-set',
        class RoProductContentProductSet extends HTMLElement {
          constructor() {
            super();
            this.selectedOption = null;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.options = this.querySelectorAll('.pq-product-content-product-set__option');
            this.bindEvents();

            // 监听页面可见性变化（移动端返回页面时触发）
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) {
                this.setInitialSelection();
              }
            });

            // 监听 pageshow 事件（捕获浏览器前进/返回操作）
            window.addEventListener('pageshow', (e) => {
              if (e.persisted) {
                // 从 bfcache 返回，重新初始化
                this.setInitialSelection();
              }
            });

            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectOption(option);
              });
            });
          }

          setInitialSelection() {
            // 通过当前页面 URL 匹配选项
            const currentPath = window.location.pathname;
            const currentOption = Array.from(this.options).find((opt) => {
              try {
                const optionUrl = new URL(opt.href, window.location.origin);
                return optionUrl.pathname === currentPath;
              } catch (e) {
                // 如果 href 是相对路径，直接比较
                return opt.getAttribute('href') === currentPath;
              }
            });

            if (currentOption) {
              this.selectOption(currentOption, false);
            } else {
              // 如果没有找到匹配的，保持第一个选中状态
              const selectedOption = this.querySelector('.pq-product-content-product-set__option.selected');
              if (selectedOption) {
                this.selectedOption = selectedOption;
              }
            }
          }

          selectOption(option, navigate = true) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;

            // 如果需要导航，跳转到产品页面
            if (navigate && option.href) {
              window.location.href = option.href;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
